/* Keep Shopify's success/error message with the form that was submitted. */
document.addEventListener('DOMContentLoaded', function () {
  var storageKey = 'ytag-contact-last-form';
  var customerForm = document.getElementById('ContactForm');
  var businessForm = document.getElementById('BusinessContactForm');
  [[customerForm, 'customer'], [businessForm, 'business']].forEach(function (item) {
    if (!item[0]) return;
    item[0].addEventListener('submit', function () {
      try {
        sessionStorage.setItem(storageKey, JSON.stringify({ audience: item[1], at: Date.now() }));
      } catch (error) {
        // Submission remains available if session storage is disabled.
      }
    });
  });

  var feedback = document.querySelectorAll('[data-contact-feedback]');
  if (!feedback.length) return;
  var audience = '';
  if (location.hash === '#BusinessContactForm') audience = 'business';
  if (location.hash === '#ContactForm') audience = 'customer';
  if (!audience) {
    try {
      var saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      if (saved && Date.now() - saved.at < 600000) audience = saved.audience;
    } catch (error) {
      // A missing or blocked storage entry should not prevent form use.
    }
  }
  if (!audience) return;
  feedback.forEach(function (element) {
    if (element.dataset.contactFeedback !== audience) element.hidden = true;
  });
  var otherForm = audience === 'business' ? customerForm : businessForm;
  if (otherForm) {
    otherForm.querySelectorAll('.contact__field-error').forEach(function (element) {
      element.hidden = true;
    });
    otherForm.querySelectorAll('[aria-invalid="true"]').forEach(function (element) {
      element.removeAttribute('aria-invalid');
      element.removeAttribute('aria-describedby');
    });
  }
});
